import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import { colors, DisplayItem, SearchableDropDown } from 'design-system';
import { Trash2 } from 'react-feather';
import { BriefcaseIcon } from 'src/components/Icons';
import { AdditionalBrokerForm } from '../customFormHelpers';

const useStyle = makeStyles(() => ({
  linkStyle: {
    '&:hover, &:focus': {
      backgroundColor: `${colors.white}`,
    },
    textAlign: 'center',
    minWidth: 0,
    padding: 0,
  },
  headlineText: {
    fontSize: 19,
    fontWeight: 900,
    lineHeight: '24px',
    marginLeft: 6,
  },
  brokerageAdditional: {
    backgroundColor: colors.cloud,
    padding: 10,
    marginBottom: 20,
  },
  inputStyles: {
    '& .Mui-disabled': {
      color: colors.madison,
    },
  },
  brokeragePercent: {
    '& .MuiInput-root': {
      height: 20,
    },
  },
}));

type Props = {
  dropdownBrokers: DisplayItem[];
  brokerPercentage: number;
  broker: AdditionalBrokerForm;
  index: number;
  deleteBroker: (id: string) => void;
  changeBroker: (id: string, value: string) => void;
};

const AdditionalBrokersCard = ({
  broker,
  dropdownBrokers,
  brokerPercentage,
  index,
  deleteBroker,
  changeBroker,
}: Props): JSX.Element => {
  const classes = useStyle();

  return (
    <Grid
      item
      container
      xs={12}
      className={classes.brokerageAdditional}
      spacing={2}
    >
      <Grid item container wrap="nowrap" justifyContent="space-between" xs={12}>
        <Grid item container wrap="nowrap">
          <BriefcaseIcon />
          <Typography className={classes.headlineText}>
            Licencia adicional
          </Typography>
        </Grid>
        <Grid item>
          <Button
            id={`sales-web-button-remove-additional-license-${index}`}
            data-testid="remove-additional-license"
            className={classes.linkStyle}
            onClick={() => deleteBroker(broker.id)}
          >
            <Trash2 color={colors.bright_turquoise} />
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchableDropDown
          inputId={`sales-web-dropdown-additional-license-${index}`}
          inputName="additional-license"
          inputLabel="Selecciona la licencia"
          options={dropdownBrokers}
          optimized
          defaultValue={broker.value}
          onChange={(newVal): void => {
            changeBroker(broker.id, newVal.Value);
          }}
          inputError={broker.error}
          inputErrorMessage={broker.errorText}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid item style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Typography style={{ color: '#B8B8B8' }} variant="caption">
            Porcentaje de Participación
          </Typography>
          <Typography
            style={{ fontWeight: 900, marginTop: -5 }}
            data-testid="broker-percentage"
          >
            {brokerPercentage}%
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdditionalBrokersCard;
